import React from "react";
import Logo from "../FooterSection/FooterImages/Logo.png";
import google from "../FooterSection/FooterImages/google.png";
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { CiInstagram } from "react-icons/ci";

const Footer = () => {
  return (
    <>
      {/* === Main Footer Content === */}
      <footer className="border-t border-gray-300 bg-white">
        <div
          className="
            container mx-auto px-5 sm:px-8 lg:px-[90px] py-12 lg:py-20
            grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-20
          "
        >
          {/* === Logo + Description === */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left">
            <img
              src={Logo}
              alt="Logo"
              className="w-40 sm:w-44 lg:w-[123px] mb-5"
            />
            <p className="text-[#718096] text-sm sm:text-[15px] lg:text-[16px] leading-relaxed max-w-[280px]">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </p>
            <img
              src={google}
              alt="Google Review"
              className="w-[180px] sm:w-[199px] border border-gray-300 rounded-md mt-6"
            />
          </div>

          {/* === Links === */}
          <div className="text-center lg:text-left">
            <p className="font-[700] text-[#4a5568] text-[18px] mb-4">
              Links
            </p>
            <ul className="text-[15px] sm:text-[16px] text-[#718096] space-y-2 leading-8">
              <li className="hover:text-[#c6477f] cursor-pointer">About Us</li>
              <li className="hover:text-[#c6477f] cursor-pointer">Services</li>
              <li className="hover:text-[#c6477f] cursor-pointer">Case Studies</li>
              <li className="hover:text-[#c6477f] cursor-pointer">How it Works</li>
              <li className="hover:text-[#c6477f] cursor-pointer">Blog & Careers</li>
              <li className="hover:text-[#c6477f] cursor-pointer">Areas We Serve</li>
            </ul>
          </div>

          {/* === Contact Info === */}
          <div className="text-center lg:text-left">
            <p className="font-[700] text-[#4a5568] text-[18px] mb-4">
              Contact Us
            </p>
            <p className="text-[#718096] text-[15px] sm:text-[16px] leading-relaxed mb-4">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </p>
            <p className="text-[#718096] text-[15px] sm:text-[16px] font-medium">
              +908 89097 890
            </p>
          </div>

          {/* === Social Icons === */}
          <div className="flex justify-center lg:justify-start items-start lg:items-end">
            <div
              className="
                flex gap-6 sm:gap-8 text-[#4a5568] text-[20px] mt-6 lg:mt-0
              "
            >
              <FaFacebookF className="hover:text-[#c6477f] cursor-pointer transition" />
              <CiInstagram className="hover:text-[#c6477f] cursor-pointer transition" />
              <FaTwitter className="hover:text-[#c6477f] cursor-pointer transition" />
              <FaLinkedinIn className="hover:text-[#c6477f] cursor-pointer transition" />
            </div>
          </div>
        </div>

        {/* === Copyright Bar === */}
        <div className="w-full border-t border-gray-300 py-6 bg-[#f9fafb]">
          <p className="text-[13px] sm:text-[14px] text-center font-[400] text-[#4a5568]">
            © 2023 Copyright by <span className="font-semibold">Agency Solutions</span>. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
